import { render, staticRenderFns } from "./settingFinancePage.vue?vue&type=template&id=335c46b1&"
import script from "./settingFinancePage.vue?vue&type=script&lang=js&"
export * from "./settingFinancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports